export const YAVRIO_ADDRESS = Object.freeze({
    WEBSITE: "https://www.yavr.io",
    PRIVACY_POLICY: "https://www.yavr.io/privacy-policy",
    TERMS_AND_CONDITIONS: "https://www.yavr.io/terms-and-conditions",
    LOGO: "https://cdn.prod.website-files.com/663d238c756e0eb5ebbde530/68f20f4b7dffea8577d618d1_logo-black.png",
    SUPPORT_EMAIL: "support@yavr.io",
});

export const ADYEN_ADDRESS = Object.freeze({
    PRIVACY_POLICY: "https://www.adyen.com/privacy-policy",
});

export const PAYMENT_LINK_TERMS_PAGE_TITLE = "Payment Link Terms | Yavrio";

export const PAYMENT_LINK_TERMS_TOP_ANCHOR_ID = "payment-link-terms-top";

export const YAVRIO_COMPANY_DISCLAIMER =
    "YAVRIO LTD 13983846. 86-90 Paul Street, London, England, EC2A 4NE. FCA Registered FRN: 974097";

export const YAVRIO_TAGLINE = "The banking, payments and treasury application designed for ERP.";
